import React from "react";
import { Nav } from "react-bootstrap";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./Sidebar.css";

import {
  FaTachometerAlt,
  FaUserFriends,
  FaCar,
  FaCog,
  FaSignOutAlt,
  FaFolder,
} from "react-icons/fa";


const Sidebar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    const confirm = window.confirm("Are you sure you want to logout?");
    if (confirm) {
      localStorage.removeItem("token");
      navigate("/admin-login");
    }
  };
  
  return (
    <div
      className="d-flex flex-column text-white p-3 sidebar"
      style={{
        width: "300px",
        minHeight: "100%",
        backgroundColor: "grey",
        color: "white",
        padding: "20px",
      }}
    >
      <Nav className="flex-column">
        {/* <Nav.Link
          as={NavLink}
          to="/admin-dashboard/dashboard"
          className={({ isActive }) =>
            `text-white ${isActive ? "active-link" : ""}`
          }
        >
          <FaTachometerAlt className="me-2" />
          Dashboard
        </Nav.Link> */}

        <Nav.Link
          as={NavLink}
          to="/admin-dashboard/admins"
          className={({ isActive }) =>
            `text-white ${isActive ? "active-link" : ""}`
          }
        >
          <FaTachometerAlt className="me-2" />
          Admin
        </Nav.Link>
        <Nav.Link
          as={NavLink}
          to="/admin-dashboard/roles"
          className={({ isActive }) =>
            `text-white ${isActive ? "active-link" : ""}`
          }
        >
          <FaTachometerAlt className="me-2" />
          Roles-Management
        </Nav.Link>

        <Nav.Link
          as={NavLink}
          to="/admin-dashboard/category"
          className={({ isActive }) =>
            `text-white ${isActive ? "active-link" : ""}`
          }
        >
          <FaFolder className="me-2" />
          Categories
        </Nav.Link>

        <Nav.Link
          as={NavLink}
          to="/admin-dashboard/cars"
          className={({ isActive }) =>
            `text-white ${isActive ? "active-link" : ""}`
          }
        >
          <FaCar className="me-2" />
          Cars
        </Nav.Link>

        {/* <Nav.Link
          as={NavLink}
          to="/admin-dashboard/user"
          className={({ isActive }) =>
            `text-white ${isActive ? "active-link" : ""}`
          }
        >
          <FaUserFriends className="me-2" />
          Users
        </Nav.Link> */}

        {/* <Nav.Link
          as={NavLink}
          to="/admin-dashboard/settings"
          className={({ isActive }) =>
            `text-white ${isActive ? "active-link" : ""}`
          }
        >
          <FaCog className="me-2" />
          Settings
        </Nav.Link> */}
        <Nav.Link
          as={NavLink}
          to="/admin-dashboard/carbooking"
          className={({ isActive }) =>
            `text-white ${isActive ? "active-link" : ""}`
          }
        >
          <FaCar className="me-2" />
          Carbookings
        </Nav.Link>

        <Nav.Link onClick={handleLogout} className="text-white mt-auto">
          <FaSignOutAlt className="me-2" />
          Logout
        </Nav.Link>
      </Nav>
    </div>
  );
};

export default Sidebar;
